import Group from 'components/utils/Group'
import BodyText from '../Typography/BodyText'
import Heading from '../Typography/Heading'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import config from 'constants/config'
import { getPlural } from 'lib/string/pluralize'
import { rem } from 'polished'
import styled from 'styled-components'

const PointText = styled(BodyText)`
  line-height: ${rem(20)};
`

interface Props {
  points: number
  size: 'S' | 'L'
}

function PriceRowPointsSpend(props: Props) {
  const { points, size } = props
  return <Group direction="horizontal" gap={2} verticalAlign="start">
    <Heading variant={size === 'S' ? 'heading6' : 'heading4'}>
      <FormatDecimal value={points} maximumFractionDigits={0} />
    </Heading>
    <PointText variant="small">
      {getPlural(config.loyalty.pointsUnitAbbreviation)}
    </PointText>
  </Group>
}

export default PriceRowPointsSpend
